import { observer } from "mobx-react";
import "./index.scss";
import H2 from "../H2";
import ContentState from "../../../../stores/ContentState";
import P18 from "../P18";
import MissionImage from "../MissionImage";
import H3 from "../H3";
import classNames from "classnames";
import MissionList from "../MissionList";
import { useInView } from "react-intersection-observer";
import AnimatedBlock from "../AnimatedBlock";
const Culture = () => {
  const { ref, inView, entry } = useInView({
    threshold: 0.5,
    triggerOnce: true,
  });
  const { culture } = ContentState.mission;
  return (
    <section className="culture">
      <H2 text={culture?.title} />
      <AnimatedBlock>
        <div className="culture__slogan">
          <h3
            className="culture__slogan-title"
            dangerouslySetInnerHTML={{ __html: culture?.sloganTitle }}
          ></h3>
          <P18 text={culture?.sloganText} />
        </div>
      </AnimatedBlock>
      <AnimatedBlock>
        <div className="culture__block">
          <P18 text={culture?.text} />
        </div>
      </AnimatedBlock>
      <AnimatedBlock>
        <div className="culture__flag">
          {culture?.block?.map((c: any, i: number) => (
            <div
              className={classNames("culture__flag-item", i && "dark")}
              key={i}
            >
              <H3 text={c} />
            </div>
          ))}
        </div>
      </AnimatedBlock>
      <AnimatedBlock>
        <div className="culturedesc">
          <MissionImage src={culture?.src} />
        </div>
        <div className="culturemodi">
          <MissionImage src={culture?.srcMobi} />
        </div>
          
      </AnimatedBlock>
      <AnimatedBlock>
        <div className="culture__block">
          <P18 text={culture?.text2} />
        </div>
      </AnimatedBlock>
      <div className="culture__list">
        <MissionList
          block={{
            listTitle: culture?.listTitle,
            list: culture?.list,
          }}
        />
      </div>
    </section>
  );
};

export default observer(Culture);
